<cdk-virtual-scroll-viewport (scroll)="onTableScroll($event)" class="list" itemSize="35">
  <table [dataSource]="this" [multiTemplateDataRows]="true" class="table" mat-table>
    <ng-container matColumnDef="id">
      <th *matHeaderCellDef class="tableBg" mat-header-cell> No.</th>
      <td *matCellDef="let element" mat-cell> {{element.id}} </td>
    </ng-container>

    <ng-container matColumnDef="timestamp">
      <th *matHeaderCellDef class="tableBg" mat-header-cell> Time</th>
      <td *matCellDef="let element" mat-cell> {{util.dateToDateTimeString(element?.timestamp?.value, true)}} </td>
    </ng-container>

    <ng-container matColumnDef="datatype">
      <th *matHeaderCellDef class="tableBg" mat-header-cell> Datatype</th>
      <td *matCellDef="let element" mat-cell> {{element.datatype}} </td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th *matHeaderCellDef class="tableBg" mat-header-cell> Text</th>
      <td *matCellDef="let element" mat-cell> {{element.value}} </td>
    </ng-container>

    <ng-container matColumnDef="causedBy">
      <th *matHeaderCellDef class="tableBg" mat-header-cell> CausedBy</th>
      <td *matCellDef="let element" mat-cell> {{element.causedBy?.name}} </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>

    <!-- cdkVirtualScrollViewport uses transform: translateY to correct for all elements that are removed.
    We will use a placeholder row in the table instead because the translate causes problems with the sticky header -->
    <tr *matRowDef="let row; let index = index; columns: []; when: placeholderWhen" [style.height.px]="placeholderHeight"
        mat-row></tr>

    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>
  <div class="spinnerWrapper">
    <ng-container *ngIf="loading">
      <sb-icon [animationOptions]="{autoplay: true, loop:true}" class="loadingSpinnerSVG" icon="loadingBlockAnimation"
               style="font-size: 2rem"></sb-icon>
      <span>{{'lang.globals.pleaseWait' | translate}}</span>
    </ng-container>
  </div>
</cdk-virtual-scroll-viewport>
